import { useLocation } from "@reach/router";
import { graphql, useStaticQuery } from "gatsby";
import useEventDetails from "./useEventDetails";

export default function getEventSchema() {
  const {
    allSpeakersJson: { speakers },
    site: { siteMetadata },
  } = useStaticQuery(graphql`
    query eventSchema {
      allSpeakersJson {
        speakers: nodes {
          image
          name
          title
        }
      }
      site {
        siteMetadata {
          title
          defaultImage: image
          url
          producer
          producerSite
          description
          facebookImage
          twitterUsername
          twitterImage
          favicon
          location
          streetAddress
          addressLocality
          postalCode
          addressRegion
          addressCountry
        }
      }
    }
  `);

  const { pathname } = useLocation();
  const {
    title,
    defaultImage,
    description,
    url,
    facebookImage,
    twitterImage,
    producer,
    producerSite,
    location,
    streetAddress,
    addressLocality,
    postalCode,
    addressRegion,
    addressCountry,
  } = siteMetadata;

  const performer = speakers.map(
    (speaker: { image: string; name: string; title: string }) => {
      const { image, name, title } = speaker;
      return { "@type": "Person", image, name, jobTitle: title };
    }
  );
  const image = [defaultImage, facebookImage, twitterImage];
  const { virtual } = useEventDetails();
  const eventType: "Offline" | "Online" = virtual ? "Online" : "Offline";

  const Schema = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: title,
    startDate: process.env.GATSBY_EVENT_START_TIME ?? new Date(),
    endDate: process.env.GATSBY_EVENT_END_TIME,
    eventAttendanceMode: `https://schema.org/${eventType}EventAttendanceMode`,
    eventStatus: "https://schema.org/EventScheduled",
    location: [
      {
        "@type": "VirtualLocation",
        url: `${url}${pathname}`,
      },
      {
        "@type": "Place",
        name: location,
        address: {
          "@type": "PostalAddress",
          streetAddress,
          addressLocality,
          postalCode,
          addressRegion,
          addressCountry,
        },
      },
    ],
    image,
    description,
    offers: {
      "@type": "Offer",
      url,
      price: "300", // We just need some fixed amount in here to please the schema code
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
      validFrom: process.env.GATSBY_EVENT_END_TIME,
    },
    performer,
    organizer: {
      "@type": "Organization",
      name: producer,
      url: producerSite,
    },
  };

  return Schema;
}
